import { Box } from "@chakra-ui/react";
import { addDays, format, getDate, getMonth } from "date-fns";
import React, { useEffect, useState } from "react";
import {
    Bar,
    BarChart,
    CartesianGrid,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis
} from "recharts";
import { Loader } from "../../components/Loader";
import { Title } from "../../components/Title";
import { useCallsReportLazyQuery } from "../../graphql";
import { DatesFilter } from "../Call/filter";

const CallsReport: React.FC = () => {
    const [startDate, setStartDate] = useState(addDays(new Date(), -30));
    const [endDate, setEndDate] = useState(addDays(new Date(), 0));

    const [callsReport, { data, loading }] = useCallsReportLazyQuery({});

    useEffect(() => {
        callsReport({
            variables: {
                range: {
                    from: format(startDate, "yyyy-MM-dd"),
                    to: format(endDate, "yyyy-MM-dd")
                }
            }
        });
    // eslint-disable-next-line
  }, []);

    const chartData = data?.callsReport?.map((i) => {
        const date = new Date(i.date);
        const month = getMonth(date);
        const day = getDate(date);

        return {
            name: `${day}/${month + 1}`,
            telefonata: i.value
        };
    });

    return (
        <>
            <Box borderWidth="1px" borderRadius="lg" background="#FFF" p="10px">
                <Title title="Telefonatat sipas datave">
                    <Box marginRight="150px">
                        <DatesFilter
                            onChange={ (i) => {
                                callsReport({
                                    variables: {
                                        range: {
                                            from: format(i.startDate, "yyyy-MM-dd"),
                                            to: format(i.endDate, "yyyy-MM-dd")
                                        }
                                    }
                                });
                            } }
                        ></DatesFilter>
                    </Box>
                </Title>

                { loading ? (
                    <Loader />
                ) : (
                    <ResponsiveContainer width="100%" height={ 500 }>
                        <BarChart
                            width={ 700 }
                            height={ 500 }
                            data={ chartData }
                            margin={ {
                                top: 5,
                                right: 30,
                                left: 20,
                                bottom: 5
                            } }
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                            { /* <Legend /> */ }
                            <Bar dataKey="telefonata" fill="#205aa7" />
                        </BarChart>
                    </ResponsiveContainer>
                ) }
            </Box>
        </>
    );
};

export default CallsReport;
